/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/15/21
 */

import {authExchange} from "@urql/exchange-auth";
import {UserState} from "../../state/reducers/user";
import {parseISO} from "date-fns";

export default function getAuthExchange (user: UserState) {
	return authExchange<{ expires: Date }>({
		async getAuth({ authState }) {
			if (!authState) {
				if (user?.sessionExpires) {
					return { expires: parseISO(user.sessionExpires) }
				}
				return null;
			}
			return null;
		},
		addAuthToOperation: ({ operation }) => {
			return operation;
		},
		didAuthError: ({ error }) => error.graphQLErrors.some(e => e.extensions?.code === 'FORBIDDEN'),
		willAuthError: ({ authState }) => {
			return !!authState?.expires && new Date() > authState?.expires;
		}
	})
}